var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"m.551 13.728-.702-.712L8.843 4.15l8.885 8.867-.707.708L8.84 5.559z"}));
}

ArrowTop.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
